<template>
  <div class="o-toolbar">
    <div class="o-toolbar__left">
      <h2 class="c-heading-2">Bevestiging</h2>
    </div>
  </div>
  <router-view></router-view>
</template>
